module.exports = __webpack_public_path__ + "img/Italy.5f287b4c.svg";